import { render, staticRenderFns } from "./CommentLikeBoard.vue?vue&type=template&id=1a6aa32f&scoped=true"
import script from "./CommentLikeBoard.vue?vue&type=script&lang=js"
export * from "./CommentLikeBoard.vue?vue&type=script&lang=js"
import style0 from "./CommentLikeBoard.vue?vue&type=style&index=0&id=1a6aa32f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6aa32f",
  null
  
)

export default component.exports